<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='User Activity')
    activity-table.content-table
</template>

<script>
  import ActivityTable from '../../shared-components/userActivity/activityTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      ActivityTable,
      Breadcrumbs
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/activity/UserActivity.vue